import { Link } from "../../../../../types/link";
import { extractRelName } from "../../linkUtils";
import { Action } from "../actions";

type LinkState = Link[];

const reducer = (state: LinkState = [], action: Action): LinkState => {
  switch (action.type) {
    case "SESSION_FETCHED":
      return [...state, ...(action.user ? action.user.link : [])];

    case "STORE_ENTRYPOINT":
      return [...state, ...action.entrypoint.rootLinks];

    case "ORGANISATIONS_FETCHED":
      return [...state, ...action.org.link];

    case "INTEGRATION_PARTNER_REGISTERED":
      return [...state, ...action.link];

    case "CERTIFICATE_FETCHED":
      return [...state, ...action.certificate.link];

    case "REOPEN_LINK_RECEIVED":
      return [...state, ...action.link];

    default:
      return state;
  }
};

export default function linkReducer(
  state: LinkState,
  action: Action,
): LinkState {
  // Vi fjerner duplikater
  return reducer(state, action)
    .map((link: Link): Link => {
      return {
        ...link,
        name: extractRelName(link),
      };
    })
    .filter((s1: Link, pos: number, arr: Array<Link>): boolean => {
      return arr.findIndex((s2) => s2.name === s1.name) === pos;
    });
}
